import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, isArray, isNull } from 'lodash';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Form as FormUI } from '~/components/Form';
import { t, number } from '~/helpers';
import { toast } from 'react-toastify';
import { get, isNumber } from 'lodash';
import api from '~/services/api';
import { Input, Autocomplete, InputText } from '~/components/Form';
import { Spinner } from '~/components';
import { SelectComplete } from '~/componentslocal';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import { Container } from './styles';
import {
  updateOperacaoPreRecebimento,
  changeModal
} from '~/store/modules/operacaoprerecebimento/actions';


const EditarPreRecebimento = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const formRef = React.useRef(ref);
  const [data, setData] = useState(null);
  const [selected, setSelected] = React.useState([]);
  const { usuarioacesso } = useSelector((state) => state.user);
  const { onCloseModal, formEdit } = props;

  const { params, toggleModal } = useSelector(
    (state) => state.operacaoprerecebimento
  );

  const testeState = useSelector((state) => state.operacaoprerecebimento)

  const [isLoading, setIsLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  //Variavei para EDITAR
  const [codEditPrreCodigo, setCodEditPrreCodigo] = React.useState('');
  const [codEditPrreStatus, setCodEditPrreStatus] = React.useState(0);

  //Variaveis do DADOS DA NOTA FISCAL (DNF)

  const [pedidoDNF, setPedidoDNF] = React.useState('');
  const [notaFiscalDNF, setNotaFiscalDNF] = React.useState('');
  const [emissaoNFDNF, setEmissaoNFDNF] = React.useState('');
  const [volumeDNF, setVolumeDNF] = React.useState('');
  const [precoUnitDNF, setPrecoUnitDNF] = React.useState('');
  const [valorTotalDNF, setValorTotalDNF] = React.useState('');
  const [combustivelDNF, setCombustivelDNF] = React.useState('');
  const [distribuidoraDNF, setDistribuidoraDNF] = React.useState('');
  const [transportadoraDNF, setTransportadoraDNF] = React.useState('');
  const [placaCTDNF, setPlacaCTDNF] = React.useState('');
  const [motoristaDNF, setMotoristaDNF] = React.useState('');
  const [orgaoDNF, setOrgaoDNF] = React.useState('');

  const [codigoCombustivelDNF, setCodigoCombustivelDNF] = React.useState('');


  //Variaveis do DADOS DA UNIDADE RECEPTORA DO PRODUTO (DURP)
  //const [prodCodLista, setProdCodLista] = React.useState('');
  const [notaFiscalDURP, setNotaFiscalDURP] = React.useState('');
  const [valueOrgaoDURP, setValueOrgaoDURP] = React.useState(0);
  const [inputValueOrgaoDURP, setInputValueOrgaoDURP] = React.useState('');
  const [dataNfRetornoDURP, setDataNfRetornoDURP] = React.useState({});
  const [atualizaEntradadosDURP, setAtualizaEntradadosDURP] = React.useState(
    false
  );
  const [clearOrgao, setClearOrgao] = useState(false)
  //Variaveis do RESUMO DO RECBIMENTO PROVISÓRIO RPR
  const [volumeTotalRPF, setVolumeTotalRPF] = React.useState(0);
  const [atualizaRPF, setAtualizaRPF] = React.useState(false);

  const [produtoRPF, setProdutoRPF] = React.useState('');

  //Variaveis d GRIDE NOTA FISCAL (GNF)
  const [rowsGNF, setRowsGNF] = React.useState([]);

  const [pocoRecebeFracioando, setPocoRecebeFracioando] = React.useState(false);

  //Variaveis para Editar
  const [preRecebimentoVO, setPreRecebimentoVO] = React.useState([]);


  const [exibircontratogta, setExibircontratogta] = React.useState(0);
  const [contratogta, setContratogta] = React.useState('');
  const [contratogtaTela, setContratogtaTela] = React.useState('');
  const [pococodigo, setPococodigo] = React.useState('');
  const [usua_login_recebedor_responsavel, setUsua_login_recebedor_responsavel] = React.useState('');
  const [usua_nome, setUsua_nome] = React.useState('');
  const [usua_cpf, setUsua_cpf] = React.useState('');
  const [prre_num_ano_empenho, setPrre_num_ano_empenho] = React.useState('');



  //********************************** */
  //Verificar modo de constulta pelo posto.
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      // console.log('usuarioacesso = ', usuarioacesso);

      const poco_recebimento_fracionado = get(
        usuarioacesso,
        'poco_recebimento_fracionado',
        ''
      );

      const poco_codigo = get(
        usuarioacesso,
        'poco_codigo',
        ''
      );

      setPococodigo(poco_codigo);

      if (String(poco_recebimento_fracionado) !== '') {
        if (String(poco_recebimento_fracionado) === 'S') {
          setPocoRecebeFracioando(true);
        } else {
          setPocoRecebeFracioando(false);
        }
      } else {
        setPocoRecebeFracioando(false);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [usuarioacesso]);



  //********************************** */
  //Effect para setDataNfRetornoDURP.
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      const dataNfRetorno = get(dataNfRetornoDURP, 'desc_nf', '');
      if (dataNfRetorno === '') {
        return;
      }
      //Regra 01
      async function localVerificaSeNFJaEstaNaLista() {
        const estaNalista = await verificaSeNFJaEstaNaLista(
          dataNfRetornoDURP.desc_nf
        );

        if (estaNalista) {
          setAtualizaEntradadosDURP(false);
          limpaDadosNotaFiscal();
          toast.error('Nota fiscal já está incluida na lista!');
          return 1;
        }
        return 0;
      }
      if (!localVerificaSeNFJaEstaNaLista()) {
        return;
      }

      //Regra 02
      async function localVerificaSeProdutoNaLista() {
        const estaNalista = await verificaSeProdutoNaLista(
          dataNfRetornoDURP.prod_display
        );

        if (estaNalista) {
          limpaDadosNotaFiscal();
          setAtualizaEntradadosDURP(false);
          toast.error(
            'O produto da Nota fiscal divergente do que está incluído no recebimento provisório!'
          );
          return 1;
        }
        return 0;
      }
      if (!localVerificaSeProdutoNaLista()) {
        return;
      }
      setAtualizaEntradadosDURP(true);
    }
    return function cleanup() {
      mounted = false;
    };
  }, [dataNfRetornoDURP]);

  //********************************** */
  //Atualiza DADOS DA NOTA FISCAL
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!atualizaEntradadosDURP) {
        return;
      }
      setPedidoDNF(dataNfRetornoDURP.desc_num_pedido);
      setNotaFiscalDNF(dataNfRetornoDURP.desc_nf);
      setEmissaoNFDNF(dataNfRetornoDURP.desc_dt_emissao_nf);
      setVolumeDNF(dataNfRetornoDURP.desc_volume_nf);
      setPrecoUnitDNF(dataNfRetornoDURP.desc_preco_unitario);
      setValorTotalDNF(dataNfRetornoDURP.desc_valor_total);
      setCombustivelDNF(dataNfRetornoDURP.prod_display);
      setDistribuidoraDNF(dataNfRetornoDURP.desc_distribuidora);
      setTransportadoraDNF(dataNfRetornoDURP.desc_transportadora);
      setPlacaCTDNF(dataNfRetornoDURP.desc_placa_ct);
      setMotoristaDNF(dataNfRetornoDURP.desc_motorista);
      setOrgaoDNF(dataNfRetornoDURP.nfre_destinat_nome);
      setCodigoCombustivelDNF(dataNfRetornoDURP.prod_codigo);
    }
    return function cleanup() {
      mounted = false;
    };
  }, [atualizaEntradadosDURP]);

  //Verificar se a Nota fiscal já está incluida na lista!
  function verificaSeNFJaEstaNaLista(nf) {
    let listaNf = rowsGNF;
    for (let i = 0; i < listaNf.length; i++) {
      if (listaNf[i].nf === nf) {
        return 1;
      }
    }
    return 0;
  }


  //Verificar se a Nota fiscal já está incluida na lista!
  function verificaSeProdutoNaLista(produto) {
    let listaNf = rowsGNF;
    for (let i = 0; i < listaNf.length; i++) {
      if (listaNf[i].produto !== produto) {
        return 1;
      }
    }
    return 0;
  }


  //Remover item da gride de nota fiscais
  function removerNFHandler() {
    if (rowsGNF.length > 1) {
      let listaIncluidos = selected;
      let listaNf = rowsGNF;
      let novaListaNf = [];
      let retir = false;
      for (let i = 0; i < listaNf.length; i++) {
        for (let x = 0; x < listaIncluidos.length; x++) {
          if (listaNf[i].nf === listaIncluidos[x]) {
            listaIncluidos.splice(x, 1);
            retir = true;
            break;
          }
        }
        if (!retir) {
          novaListaNf.push(listaNf[i]);
        }
        retir = false;
      }
      setRowsGNF(novaListaNf);
      setSelected([]);
      setAtualizaRPF(true);
    } else {
      toast.error('Você deve manter pelo menos um registro na tabela para salvar a edição!')
    }

  }


  function createData(nf, produto, codorgao, descorgao, volume) {
    return { nf, produto, codorgao, descorgao, volume };
  }

  function limpaDadosPesquisaNotaFiscal() {
    formRef.current.setFieldValue('notaFiscalDURP', '')
    setNotaFiscalDURP('')
    setClearOrgao(true)
    setDataNfRetornoDURP({});
    setAtualizaEntradadosDURP(false);
  }


  function limpaDadosNotaFiscal() {
    setPedidoDNF('');
    setNotaFiscalDNF('');
    setEmissaoNFDNF('');
    setVolumeDNF('');
    setPrecoUnitDNF('');
    setValorTotalDNF('');
    setCombustivelDNF('');
    setDistribuidoraDNF('');
    setTransportadoraDNF('');
    setPlacaCTDNF('');
    setMotoristaDNF('');
    setOrgaoDNF('');
  }


  //Funcoes para DADOS DA UNIDADE RECEPTORA DO PRODUTO (DURP)
  //Busca Nota Fiscal
  async function buscaNotaFiscalDURPHandler() {
    limpaDadosNotaFiscal();
    setAtualizaEntradadosDURP(false);

    if (!notaFiscalDURP) {
      toast.error('NF: esta informação é obrigatória!');
      return;
    }

    if (!valueOrgaoDURP) {
      toast.error('Órgão: esta informação é obrigatória!');
      return;
    }

    let codPrreCodigo = '0';
    if (codEditPrreCodigo) {
      codPrreCodigo = String(codEditPrreCodigo);
    }

    try {
      setIsLoading(true);
      const numero_nf = notaFiscalDURP;
      const poco_codigo = get(usuarioacesso, 'poco_codigo', '');
      const orga_codigo = String(valueOrgaoDURP);
      const codigo_frentista = get(usuarioacesso, 'usua_login', '');
      const response = await api.get(
        `/prerecebimento/${codPrreCodigo}/${numero_nf}/${poco_codigo}/${orga_codigo}/${codigo_frentista}`
      );
      await setIsLoading(false);
      const dataNfRetorno = get(response, 'data', '');
      if (String(dataNfRetorno) === '') {
        toast.error('Não foi possível fazer a consulta!');
        return;
      }
      setDataNfRetornoDURP(response.data);
    } catch (err) {
      setDataNfRetornoDURP({});
      setIsLoading(false);
      toast.error(` ${err} `);
    }
  }

  function adicionarNF() {
    let newRowsGNF = [];
    const obj = createData(
      notaFiscalDNF,
      combustivelDNF,
      valueOrgaoDURP,
      inputValueOrgaoDURP,
      volumeDNF
    );
    newRowsGNF = newRowsGNF.concat(rowsGNF, obj);
    setRowsGNF(newRowsGNF);

    limpaDadosNotaFiscal();
    limpaDadosPesquisaNotaFiscal();

    setAtualizaRPF(true);
  }

  function atualizaVolumeTotalRPF() {
    let listaNf = rowsGNF;
    let total = 0.0;
    for (let i = 0; i < listaNf.length; i++) {
      const volume = Number(listaNf[i].volume);
      total = total + volume;
    }
    setVolumeTotalRPF(total);
    if (total === 0.0) {
      setProdutoRPF('');
    }
  }


  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!atualizaRPF) {
        return;
      }
      setAtualizaRPF(false);

      atualizaVolumeTotalRPF();
    }
    return function cleanup() {
      mounted = false;
    };
  }, [atualizaRPF]);


  // Open Modal
  const openModal = React.useCallback(() => {
    setOpen(true);
  }, []);

  // Close Modal
  const closeModal = React.useCallback(() => {
    setOpen(false);
  }, []);

  const handleCallbackClose = React.useCallback(async () => {
    setData({});
    if (formRef.current) {
      await formRef.current.setData({});
      await formRef.current.reset();
    }
    onCloseModal();
  }, []);


  React.useEffect(() => {
    if (!isEmpty(formEdit)) {

      // console.log(JSON.stringify(formEdit));

      async function getConfigSistema() {
        const {
          prre_codigo,
          prre_status,
          poco_codigo,
          prod_codigo,
          prod_codigo_display,

          cosi_contratogta,
          prre_num_ano_empenho,
          usua_login_recebedor_responsavel,

          notasFiscais,


        } = formEdit;

        const obj = {
          prre_codigo,
          prre_status,
          poco_codigo,
          prod_codigo_display,
          prod_codigo,

          cosi_contratogta,
          prre_num_ano_empenho,
          usua_login: usua_login_recebedor_responsavel,

          notasFiscais,
        };
        setPreRecebimentoVO(obj);
        setData(formEdit);
      }
      getConfigSistema();

    } else {

    }
  }, [formEdit]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      modoEditarDesserializar();
      //console.log(preRecebimentoVO);
    }
    return function cleanup() {
      mounted = false;
    };
  }, [preRecebimentoVO]);

  //EDITAR!!
  function modoEditarDesserializar() {
    // if (preRecebimentoVO.prre_status > 0) {
    //   dispatch(closeDialog());
    //   return;
    // }

    // console.log('preRecebimentoVO = ', preRecebimentoVO);

    let listaNf = preRecebimentoVO.notasFiscais;
    let newRowsGNF = [];

    if (listaNf) {


      setPrre_num_ano_empenho(preRecebimentoVO.prre_num_ano_empenho);

      setCodEditPrreCodigo(String(preRecebimentoVO.prre_codigo));

      setCodEditPrreStatus(preRecebimentoVO.prre_status);

      setCodigoCombustivelDNF(preRecebimentoVO.prod_codigo);

      setProdutoRPF(preRecebimentoVO.prod_codigo_display);

      for (let i = 0; i < listaNf.length; i++) {
        const nf = listaNf[i].prri_nf;
        const produto = preRecebimentoVO.prod_codigo_display;
        const codorgao = listaNf[i].orga_codigo;
        const descorgao = listaNf[i].orga_nome;
        const volume = listaNf[i].prri_volume_nf;
        const obj = createData(nf, produto, codorgao, descorgao, volume);
        newRowsGNF = newRowsGNF.concat(rowsGNF, obj);
        setRowsGNF(newRowsGNF);
      }
      setAtualizaRPF(true);
    }
  }

  const handleSubmit = React.useCallback(
    async (param, { reset }) => {
      try {

        console.log('param = ', param);

        const schema = Yup.object().shape({
          usua_login_recebedor_responsavel: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio')),
          prre_num_ano_empenho: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(30, t('s.geral.validacao.tamanhomaximo').replace('%s', 30)),
        });

        await schema.validate(param, {
          abortEarly: false,
        });

        if (volumeTotalRPF === 0) {
          toast.error('Volume não permitido para cadastro!');
          return;
        }

        if (!validaRegraDoDivisor5000()) {
          toast.error('Volume não permitido para cadastro!');
          return;
        }

        const poco_codigo = get(usuarioacesso, 'poco_codigo', '');
        const codigo_frentista = get(usuarioacesso, 'usua_login', '');

        const objSend = {
          cosi_contratogta: contratogta,
          prre_num_ano_empenho: prre_num_ano_empenho,
          usua_login_recebedor_responsavel: usua_login_recebedor_responsavel,


          poco_codigo: poco_codigo,
          prre_codigo: codEditPrreCodigo,
          prod_codigo: codigoCombustivelDNF,
          prre_login_cadastro: codigo_frentista,
          listaNotasFiscais: rowsGNF,
        };

        // console.log(  JSON.stringify(objSend));


        await dispatch(updateOperacaoPreRecebimento(objSend, params));

        formRef.current.setErrors({});
        reset();
        // closeModal();

      } catch (err) {

        console.log('err = ', err);

        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          formRef.current.setErrors(validationErrors);
        }

        // if (isArray(err)) {
        //   err.map((e) => toast.error(e));
        // }
      }
    },
    [data, contratogta, prre_num_ano_empenho, usua_login_recebedor_responsavel, volumeTotalRPF, usuarioacesso, codEditPrreCodigo, codigoCombustivelDNF, rowsGNF]
  );

  useEffect(() => {
    if (toggleModal) {
      closeModal();
      dispatch(changeModal({ closeModal: false }))
    }
  }, [toggleModal])

  // Export functions
  React.useImperativeHandle(ref, () => ({
    openModal,
  }));

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  //Só pode receber modulo 5000 CARLOS
  function validaRegraDoDivisor5000() {
    const regraDoDivisor5000 = volumeTotalRPF % 5000.0;

    if (regraDoDivisor5000 === 0) {
      return true;
    } else {
      return false;
    }
  }

  async function getConfigSistema() {
    try {
      setIsLoading(true);
      const response = await api.get(`/configsistema`);
      const statusRetorno = get(
        response,
        'data.cosi_exibircontratogta',
        'data.cosi_contratogta',
        ''
      );
      await setIsLoading(false);
      if (String(statusRetorno) === '') {
        toast.error('Não foi possível fazer a consulta!');
        return;
      }
      if (response && !isEmpty(response.data)) {
        if (String(response.data.cosi_exibircontratogta) === '1') {
          setExibircontratogta(1);
        } else {
          setExibircontratogta(0);
        }

        // console.log('response.data.cosi_contratogta = ', response.data.cosi_contratogta);

        setContratogtaTela(`Contrato nº ${response.data.cosi_contratogta}`);
        setContratogta(response.data.cosi_contratogta);

      }
    } catch (err) {
      setIsLoading(false);
      setExibircontratogta(0);
      toast.error(` ${err} `);
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getConfigSistema();
    }
    return function cleanup() {
      mounted = false;
    };
  }, []);

  return (
    <>
      {isNull(data) ? (
        <div style={{ zIndex: 999999 }}>
          <Spinner loading />
          return;
        </div>
      ) : (



        <Dialog
          disableEscapeKeyDown
          disableBackdropClick
          open={open}
          maxWidth="md"
          onExit={handleCallbackClose}
        >

          <DialogTitle>{`Editar Recebimento Provisório ${data.prre_codigo}`}</DialogTitle>

          <DialogContent >
            <Form
              // <FormUI
              ref={formRef}
              initialData={data}
              onSubmit={handleSubmit}
            >
              <Container>
                <div className="Container__grupos">

                  <div style={{ height: '3rem', width: '50rem' }}>
                    <p>{contratogtaTela}</p>
                  </div>
                  <div className="Container__editar__nf_busca">
                    <Autocomplete
                      name="usua_login_recebedor_responsavel"
                      label="usua_login"
                      title="Recebedor Responsável"
                      url="usuario/usuariolistagpp"
                      unique="usua_login_recebedor_responsavel"

                      params={{
                        wherefield: ['poco_codigo', 'USUA_STATUS'],
                        valuewherefield: [pococodigo, '1'],
                        typewherefield: ['EQUALS', 'EQUALS'],
                        fieldlist: 'usua_login, usua_nome, usua_cpf, usua_login_recebedor_responsavel',
                      }}
                      getValue={(value) => {
                        if (value.usua_login_recebedor_responsavel !== null) {
                          setUsua_login_recebedor_responsavel(value.usua_login_recebedor_responsavel);
                        } else {
                          setUsua_login_recebedor_responsavel('')
                        }

                        if (value.usua_nome !== null) {
                          setUsua_nome(value.usua_nome);
                        } else {
                          setUsua_nome('')
                        }

                        if (value.usua_cpf !== null) {
                          setUsua_cpf(value.usua_cpf);
                        } else {
                          setUsua_cpf('')
                        }
                      }}
                    />

                    <Input
                      name="prre_num_ano_empenho"
                      label="Nº/Ano do Empenho"
                      placeholder=""
                      value={prre_num_ano_empenho}
                      getValue={(value) => {
                        setPrre_num_ano_empenho(value);
                      }}
                    />
                  </div>

                  <p>DADOS DA UNIDADE RECEPTORA DO PRODUTO:</p>
                  <br />

                  <Button
                    color="primary"
                    disabled={codEditPrreStatus > 0}
                    variant="outlined"
                    onClick={buscaNotaFiscalDURPHandler}
                  >
                    {'Localizar NF'}
                  </Button>

                  <div className="Container__nf_busca">
                    <InputText
                      name="notaFiscalDURP"
                      label="NF"
                      size="small"
                      margin="dense"
                      type="number"
                      value={notaFiscalDURP}
                      getValue={(value) => {
                        setNotaFiscalDURP(value);
                      }}
                      mask="9999999999"
                      placeholder=""
                    />

                    <SelectComplete
                      name="orga_codigo"
                      label="orga_nome"
                      title="Órgão"
                      id='"orga_codigo'
                      url="orgaos"
                      unique='"orga_codigo'
                      value={valueOrgaoDURP}
                      inputValue={inputValueOrgaoDURP}
                      onChange={(event, newValue) => {
                        setValueOrgaoDURP(newValue);
                      }}
                      onInputChange={(event, newInputValueOrgao) => {
                        setInputValueOrgaoDURP(newInputValueOrgao);
                      }}
                      hiddens={[{ name: 'orga_nome' }]}
                      getValue={(value) => {
                        setClearOrgao(false)
                        if (value.orga_codigo !== null) {
                          setValueOrgaoDURP(value.orga_codigo);
                        } else {
                          setValueOrgaoDURP(0);
                        }
                      }}
                      clearField={clearOrgao}
                      disableClearable={!valueOrgaoDURP}
                    />
                  </div>

                  <p> DADOS DA NOTA FISCAL:</p>

                  <Button
                    color="primary"
                    variant="outlined"
                    disabled={atualizaEntradadosDURP === false}
                    onClick={adicionarNF}
                  >
                    {'adicionar NF'}
                  </Button>

                  <div className="Container__nf_dados">
                    <Input
                      name="desc_num_pedido"
                      label="Pedido"
                      disabled
                      value={pedidoDNF}
                    />

                    <Input
                      name="prod_display"
                      label="Combustível"
                      disabled
                      value={combustivelDNF}
                    />

                    <Input
                      name="desc_nf"
                      label="Nota Fiscal"
                      disabled
                      value={notaFiscalDNF}
                    />

                    <Input
                      name="desc_distribuidora"
                      label="Distribuidora"
                      disabled
                      value={distribuidoraDNF}
                    />

                    <Input
                      name="desc_dt_emissao_nf"
                      label="Emissão NF"
                      disabled
                      value={emissaoNFDNF}
                    />

                    <Input
                      name="desc_transportadora"
                      label="Transportadora"
                      disabled
                      value={transportadoraDNF}
                    />

                    <Input
                      name="desc_volume_nf"
                      label="Volume"
                      disabled
                      value={isNumber(volumeDNF) ?
                        number(volumeDNF, 1)
                        : ''}
                    />

                    <Input
                      name="desc_placa_ct"
                      label="Placa CT"
                      disabled
                      value={placaCTDNF}
                    />

                    <Input
                      name="desc_preco_unitario"
                      label="Preço Unit."
                      disabled
                      value={precoUnitDNF}
                    />

                    <Input
                      name="desc_motorista"
                      label="Motorista"
                      disabled
                      value={motoristaDNF}
                    />

                    <Input
                      name="desc_valor_total"
                      label="Valor Total"
                      disabled
                      value={valorTotalDNF}
                    />

                    <Input
                      name="nfre_destinat_nome"
                      label="Órgão"
                      disabled
                      value={orgaoDNF}
                    />
                  </div>

                  <p>NOTAS FISCAIS REALACIONADAS</p>
                  <Button
                    color="primary"
                    variant="outlined"
                    disabled={selected.length <= 0}
                    selected
                    onClick={removerNFHandler}
                  >
                    {'Remover NF'}
                  </Button>

                  <div className="Container__nf_dados_grade">
                    <TableContainer component={Paper}>
                      <Table
                        style={{ minWidth: 380, zIndex: -1 }}
                        size="small"
                        aria-label="simple table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="right"></TableCell>
                            <TableCell align="right">Nota Fiscal</TableCell>
                            <TableCell align="right">Produto</TableCell>
                            <TableCell align="right">Órgão</TableCell>
                            <TableCell align="right">Descrição</TableCell>
                            <TableCell align="right">Volume</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsGNF.map((row, index) => {
                            const isItemSelected = isSelected(row.nf);
                            const labelId = `enhanced-table-checkbox-${index}`;
                            return (
                              <TableRow
                                hover
                                key={row.nf}
                                onClick={(event) => handleClick(event, row.nf)}
                                selected={isItemSelected}
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                              >
                                <TableCell padding="checkbox">
                                  <Checkbox
                                    checked={isItemSelected}
                                    inputProps={{ 'aria-labelledby': labelId }}
                                  />
                                </TableCell>
                                <TableCell align="right">{row.nf}</TableCell>
                                <TableCell align="right">{row.produto}</TableCell>
                                <TableCell align="right">{row.codorgao}</TableCell>
                                <TableCell align="right">{row.descorgao}</TableCell>
                                <TableCell align="right">{number(row.volume, 1)}</TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                  <p>RESUMO DO RECBIMENTO PROVISÓRIO</p>

                  <div className="Container__nf_dados_resumo">
                    <Input
                      name="resumonftotal"
                      label="Volume total NF's:"
                      size="small"
                      margin="dense"
                      value={number(volumeTotalRPF, 1)}
                      disabled
                    />

                    <Input
                      name="resumonfproduto"
                      label="Produto:"
                      size="small"
                      margin="dense"
                      value={produtoRPF}
                      disabled
                    />

                  </div>

                  <div style={{ height: '3rem', width: '50rem' }}>
                    <p>{usua_cpf}/{usua_nome} </p>
                  </div>

                </div>
              </Container>
            </Form>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => { formRef.current.submitForm(); }}
              color="primary"
              variant="outlined"
            >
              {t('s.geral.botaosalvar')}
            </Button>

            <Button onClick={closeModal} color="secondary" variant="outlined">
              {t('s.geral.botaofechar')}
            </Button>
          </DialogActions>
        </Dialog>

      )}

    </>
  );
});

EditarPreRecebimento.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  formEdit: PropTypes.objectOf(PropTypes.any),
};

EditarPreRecebimento.defaultProps = {
  formEdit: {},
};

export default EditarPreRecebimento;
